export default "__VITE_ASSET__BsoI1jSa__"